import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html'
})
export class AppSidebarComponent {
    timeout: any = null;
    anchored: boolean = false;

    @ViewChild('menuContainer') menuContainer!: ElementRef;
    constructor(public layoutService: LayoutService, public el: ElementRef) {}

    ngAfterViewInit() {
        this.anchored = localStorage.getItem('sidebarAnchored') === 'true';
        this.layoutService.state.anchored = this.anchored;
        this.layoutService.state.sidebarActive = this.anchored;
    }
    
    onMouseEnter() {
        if (!this.layoutService.state.anchored) {
            clearTimeout(this.timeout);
            this.timeout = null;
            this.layoutService.state.sidebarActive = true;
        }
    }

    onMouseLeave() {
        if (!this.layoutService.state.anchored) {
            this.timeout = setTimeout(() => this.layoutService.state.sidebarActive = false, 300);
        }
    }

    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
        localStorage.setItem('sidebarAnchored', this.layoutService.state.anchored.toString());
    }

}
